@if (showError()) {
  <span [id]="getError()">
    {{ getError() }}
  </span>
}
